// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Selection_cardContainer__V5pOz","selectionName":"Selection_selectionName__IU8tJ","oddsBtn":"Selection_oddsBtn__Veb_U","handicap":"Selection_handicap__RN9xZ"};